import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ChangeDetectorRef,
  AfterContentChecked,
  OnDestroy,
} from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// generic interface for exposing text value changes
interface TextChangeInputType {
  textValue: string;
  maxLength: number;
  getValueChanges: () => Observable<string>;
}
type HTMLInputFieldType = HTMLInputElement | HTMLTextAreaElement;

@Component({
  selector: 'app-character-counter',
  templateUrl: './character-counter.component.html',
  styleUrls: ['./character-counter.component.scss'],
})
export class CharacterCounterComponent
  implements OnInit, AfterViewInit, AfterContentChecked, OnDestroy
{
  max: number;
  count: number;

  private ngUnsubscribe = new Subject();

  get remainingCount() {
    return this.max - this.count;
  }

  @Input()
  field: HTMLInputFieldType | TextChangeInputType;

  @Input()
  display: 'inline' | 'block' = 'block';

  @Input()
  mode: 'count' | 'remaining' = 'count';

  constructor(private ref: ChangeDetectorRef) {}

  ngOnInit() {
    this.count = 0;
    this.max = this.field.maxLength || 0;
  }

  ngAfterViewInit() {
    this.getValueChanges()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.updateCount();
      });
  }

  ngAfterContentChecked() {
    this.updateCount();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  updateCount() {
    const updateCount = this.getValue().length;

    // Manual "dirty" check
    if (this.count !== updateCount) {
      this.count = updateCount;
      this.ref.markForCheck();
    }
  }

  private getValueChanges(): Observable<any> {
    return (this.field as TextChangeInputType).getValueChanges
      ? (this.field as TextChangeInputType).getValueChanges() // text editor changes
      : fromEvent(this.field as HTMLInputFieldType, 'input'); // input value changes
  }

  private getValue(): string {
    return typeof (this.field as TextChangeInputType).textValue !== 'undefined'
      ? (this.field as TextChangeInputType).textValue // text editor value
      : (this.field as HTMLInputFieldType).value; // input value
  }
}
